import { createAction } from "redux-act";

export const OpenNewPlaygroundModalAction = createAction("New Playground - Open Modal");
export const CloseNewPlaygroundModalAction = createAction("New Playground - Close Modal");

export const PlaygroundNewAction = createAction("Playground New");
export const PlaygroundNewRequestAction = createAction("Playground New - Request");
export const PlaygroundNewSuccessAction = createAction("Playground New - Success");
export const PlaygroundNewFailedAction = createAction("Playground New - Failed");
